import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=19390198&scoped=true&"
import script from "./addShop.vue?vue&type=script&lang=js&"
export * from "./addShop.vue?vue&type=script&lang=js&"
import style0 from "./addShop.vue?vue&type=style&index=0&id=19390198&scoped=true&lang=css&"
import style1 from "./addShop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19390198",
  null
  
)

export default component.exports